import React from 'react'
import styled from 'styled-components'
import useActiveWeb3React from 'contexts/Web3Context'
import { useTotalSupply, useBurnedBalance, useEmissionValue } from 'hooks/useTokenBalance'
import { getCakeAddress } from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber, formatNumber } from 'utils/formatBalance'
import { usePriceCakeBusd } from 'state/farms/hooks'
import { Flex, Link, Text, Heading, Skeleton } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import Balance from 'components/Balance'
import ConnectWalletButton from 'components/ConnectWalletButton'
import BigNumber from 'bignumber.js'
import { BIG_TEN, BIG_ZERO } from 'utils/bigNumber'
import { CustomButton } from './CustomButton'

const StyledColumn = styled(Flex) <{ noMobileBorder?: boolean }>`
  flex-direction: column;
  ${({ noMobileBorder, theme }) =>
    noMobileBorder
      ? `${theme.mediaQueries.md} {
           padding: 0 16px;
           border-left: 1px ${theme.colors.inputSecondary} solid;
         }
       `
      : `border-left: 1px ${theme.colors.inputSecondary} solid;
         padding: 0 8px;
         ${theme.mediaQueries.sm} {
           padding: 0 16px;
         }
       `}
`

const Grid = styled.div`
  display: grid;
  grid-gap: 16px 8px;
  margin-top: 24px;
  grid-template-columns: repeat(2, auto);

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-gap: 32px;
    grid-template-columns: repeat(4, auto);
  }
`

const BunnyWrapper = styled.div`
  width: 100%;
  text-align: right;

  img {
    display: none;
    margin-left: auto;

    ${({ theme }) => theme.mediaQueries.sm} {
      display: block;
      max-width: 140px;
    }

    ${({ theme }) => theme.mediaQueries.md} {
      max-width: 180px;
    }

    ${({ theme }) => theme.mediaQueries.lg} {
      max-width: 240px;
    }
  }
`

const CakeDataRow = () => {
  const { t } = useTranslation()
  const totalSupply = useTotalSupply()
  const { account } = useActiveWeb3React()
  const emissionValue = getBalanceNumber(useEmissionValue())

  // const burnedBalance = getBalanceNumber(useBurnedBalance(getCakeAddress()))
  const burnedBalance = getBalanceNumber(BIG_TEN.pow(18 + 8).minus(totalSupply))
  // const cakeSupply = totalSupply ? getBalanceNumber(totalSupply) - burnedBalance : 0
  const cakeSupply = getBalanceNumber(totalSupply)

  const cakePriceBusd = usePriceCakeBusd()

  const mcap = cakePriceBusd.times(cakeSupply)
  // const mcapString = formatLocalisedCompactNumber(mcap.toNumber())
  const mcapString = formatNumber(mcap.toNumber())

  return (
    <Flex
      position="relative"
      flexDirection={['row', null, null, 'row']}
      alignItems={['center', null, null, 'center']}
      justifyContent="center"
    >
      <Flex flex="1" flexDirection="column">
        <Heading scale="xl" color="input" mb="8px">
          {t('BIRB')}
        </Heading>
        <Text mb="24px" color="input" fontSize="21px">
          {t('BIRB token is at the heart of the BirbSwap ecosystem. Buy it, win it, spend it, and stake it.')}
        </Text>
        <Flex>
          <Link mr="16px" href="https://pancakeswap.finance/swap?outputCurrency=0x2e8799f0A26d8A9f37a0b4747Fa534f039C2d234" target='_blank'>
            <CustomButton variant='primary'>{t('Buy Birb')}</CustomButton>
          </Link>
        </Flex>
        <Grid style={{ background: '#3c6cb0a8', border: '1px solid #1559b9', borderRadius: '15px', padding: '15px' }}>
          <Flex flexDirection="column">
            <Text color="input">{t('Total supply')}</Text>
            {cakeSupply ? (
              <Balance decimals={0} lineHeight="1.1" fontSize="24px" bold value={cakeSupply} color="input" />
            ) : (
              <Skeleton height={24} width={126} my="4px" />
            )}
          </Flex>
          <StyledColumn>
            <Text color="input">{t('Burned to date')}</Text>
            {burnedBalance || burnedBalance === 0 ? (
              <Balance decimals={0} lineHeight="1.1" fontSize="24px" bold value={burnedBalance} color="input" />
            ) : (
              <Skeleton height={24} width={126} my="4px" />
            )}
          </StyledColumn>
          <StyledColumn noMobileBorder>
            <Text color="input">{t('Market cap')}</Text>
            {mcap?.gt(0) && mcapString ? (
              <Heading scale="lg" style={{ color: '#FFF' }}>{t('$%marketCap%', { marketCap: mcapString })}</Heading>
            ) : (
              <Skeleton height={24} width={126} my="4px" />
            )}
          </StyledColumn>
        </Grid>
      </Flex>
      <Flex
        height={['fit-content', null, null, '100%']}
        width={['fit-content', null, null, '100%']}
        flex={[null, null, null, '1']}
        mb={['24px', null, null, '0']}
        position="relative"
      >
        <BunnyWrapper>
          <img src="/images/custom/home-2.png" alt={t('Home 2nd section')} />
        </BunnyWrapper>
      </Flex>
    </Flex>
  )
}

export default CakeDataRow
